import { Helper } from '../Helper';
export class CreateFunctionObjectHelper extends Helper {
    constructor({ property }) {
        super();
        this.property = property;
    }
    emit(sb, node, options) {
        if (options.pushValue) {
            sb.emitHelper(node, options, sb.helpers.createObject);
            sb.emitOp(node, 'TUCK');
            sb.emitPushInt(node, this.property);
            sb.emitOp(node, 'ROT');
            sb.emitHelper(node, options, sb.helpers.setInternalObjectProperty);
        }
    }
}

//# sourceMappingURL=CreateFunctionObjectHelper.js.map
